// Local-tangent-plane maths between site metres (x, y) and WGS84 (lat, lng).
// ref = { lat, lng, rotationDeg }. rotationDeg is a COMPASS bearing: the
// direction of the site's +y axis, clockwise from true north. That convention
// is confined to this file, its backend twin controller/ips/geo.py and the
// GeoBackdrop (D-28). Keep the two implementations in lock-step.
const A = 6378137;
const E2 = 6.69437999014e-3;
const rad = (d) => (d * Math.PI) / 180;
const deg = (r) => (r * 180) / Math.PI;

// Metres per radian of latitude (M) and of longitude at phi0 (N*cos(phi0)).
const scales = (ref) => {
  const phi0 = rad(ref.lat);
  const w = Math.sqrt(1 - E2 * Math.sin(phi0) ** 2);
  return [(A * (1 - E2)) / w ** 3, (A / w) * Math.cos(phi0)];
};

export const toSite = (ref, lat, lng) => {
  const [m, nCos] = scales(ref);
  const dN = rad(lat - ref.lat) * m;
  const dE = rad(lng - ref.lng) * nCos;
  const t = rad(ref.rotationDeg);
  return [
    dE * Math.cos(t) - dN * Math.sin(t),
    dE * Math.sin(t) + dN * Math.cos(t),
  ];
};

export const toLatLng = (ref, x, y) => {
  const [m, nCos] = scales(ref);
  const t = rad(ref.rotationDeg);
  const dE = x * Math.cos(t) + y * Math.sin(t);
  const dN = -x * Math.sin(t) + y * Math.cos(t);
  return [ref.lat + deg(dN / m), ref.lng + deg(dE / nCos)];
};
